// Types
import { ContractConsentsTypeEnum } from 'containers/contract/types/contract-api-data-api-response.type';
import { ContractConsentViewType } from '../../hooks/types/contract.view.hook.types';
import { ContractViewButtonConfigurationHandlersType } from '../types/contract.view.handlers.types';
import { IsConsentCheckedType } from './types/contract.view.handlers.utils.types';

const checkIfAllConsentsAreCorrect = (consents: ContractConsentViewType[]): boolean =>
  consents.every(consent => !consent.mandatory || consent.checked);

const updateButtonWithDisabled =
  (disabled: boolean) =>
  (
    previousConfiguration: ContractViewButtonConfigurationHandlersType
  ): ContractViewButtonConfigurationHandlersType => ({
    ...previousConfiguration,
    loading: disabled,
  });

const isConsentChecked = ({ updatedConsents, consent }: IsConsentCheckedType): boolean =>
  updatedConsents.find(consentIteration => consentIteration.type === consent)?.checked ?? false;

const isSepaConsent = (type: ContractConsentsTypeEnum): boolean =>
  type === ContractConsentsTypeEnum.SEPA_MANDATE;

export { checkIfAllConsentsAreCorrect, isConsentChecked, isSepaConsent, updateButtonWithDisabled };
